import React from 'react'
import Chart from 'react-apexcharts'
import { Col, Row } from 'react-bootstrap'
import { useSelector } from 'react-redux'
import { useGetCummulativeQuery } from '../redux/api/sessionWiseApi'

const Cummulative = ({ filters }) => {
  const { selectedUser } = useSelector((state) => state.user)
  const { data: charts, isLoading, isError, error } = useGetCummulativeQuery(
    {
      isGroup: localStorage.getItem('isGroup') || false,
      userId: selectedUser?.id,
      ...filters,
    },
    { skip: !selectedUser }
  )

  if (isLoading) return <p>Loading...</p>
  if (isError) return <p>{error.message}</p>
  if (!charts) return <p>No Data</p>

  return (
    <div>
      <h4
        className='dashboard-cards text-center'
        style={{ color: 'var(--green-color)', backgroundColor: 'var(--green-highlight-color)' }}
      >
        Improvements Across Sessions
      </h4>
      {/* <p className='fs-5' style={{ textAlign: 'justify' }}>
        Through these findings, you may uncover that your individual may excel in Math, instead of Arts because of his
        higher brain strength in Math. His thinking power gets activated the moment he sees an algebra question instead
        of a political issue. <br />
        This analysis will give you a complete picture about how the learning style of your individual gets impacted and
        how you can improve the same. For example, across the sessions we make some recommendations and based on that
        the individual starts learning via interactive content, which can improve his concentration and the stress level
        will decrease. These performance improvements are tracked on a monthly basis for each subject through our
        month-on-month sessions.
      </p> */}
      <p>
        The line chart tracks improvements across four categories: learning style, brain strength, emotional analysis,
        and performance metrics.
        <ul>
          <li>
            <strong>Learning Style:</strong> This category shows how the individual's preferred methods of learning
            evolve over time, reflecting greater adaptability and effectiveness.{' '}
          </li>
          <li>
            <strong>Brain Strength</strong>: This line illustrates the growth in cognitive abilities, indicating better
            problem-solving skills and intellectual engagement.{' '}
          </li>
          <li>
            <strong>Emotional Analysis</strong>: This category monitors changes in emotional well-being, highlighting
            reduced stress and improved emotional resilience.{' '}
          </li>
          <li>
            <strong>Performance Metrics</strong>: This line measures overall performance improvements in various tasks,
            showing enhanced productivity and effectiveness.{' '}
          </li>
        </ul>
        Each line demonstrates a positive trend, indicating continuous improvement across sessions.
      </p>
      <p className='fs-5 fw-bold' style={{ textAlign: 'justify' }}>
        Instructions: You can click on the legends to show/hide curve
      </p>
      {/* ------------------- charts ------------------------ */}
      <Row>
        {Object.entries(charts).map(([key, data], idx) => {
          let series = Object.entries(data).map(([name, values]) => ({
            name: name.charAt(0).toUpperCase() + name.slice(1),
            data: values.map((v) => Math.round(v)),
          }))

          return (
            <Col key={idx} xl={6}>
              {idx % 2 ? <div className='page-break' /> : null}
              <div className='dashboard-cards'>
                <div className='performance-heading'>
                  <h4 className='text-black'>{key.split('_').join(' ')}</h4>
                </div>

                <Chart options={options} series={series} type='line' height={300} />
              </div>
            </Col>
          )
        })}
      </Row>
    </div>
  )
}

export default Cummulative

const colorsUser = ['#6AB04C', '#F0932B', '#BC1CA4', '#22A6B3', '#ACB4EA', '#A67C00']

const options = {
  chart: {
    toolbar: {
      show: false,
    },
    zoom: {
      enabled: false,
    },
  },
  tooltip: {
    x: {
      formatter: (value, extra) => 'Session ' + value,
    },
  },
  colors: colorsUser,
  dataLabels: {
    enabled: true,
  },
  stroke: {
    curve: 'smooth',
  },

  xaxis: {
    title: {
      text: 'Sessions',
    },
  },
  yaxis: {
    tickAmount: 4,
    min: 0,
    max: 100,
  },
  legend: {
    position: 'top',
    horizontalAlign: 'right',
  },
}
